//#region src/components/currency/Currency.tsx
const Currency = ({ locale = "en-US", currency = "USD", amount }) => {
	return new Intl.NumberFormat(locale, {
		style: "currency",
		currency
	}).format(amount);
};

//#endregion
export { Currency };